export default __webpack_public_path__ + "static/media/owner-account-gray.ec08c5a1.svg";